/* Shopify product objects remain authoritative; this file only enhances the server-rendered form and gallery. */
(() => {
  const parseVariants = root => {
    try { return JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]'); }
    catch (error) { console.error('Unable to read product variants.', error); return []; }
  };

  function initialize(root) {
    if (root.dataset.productReady === 'true') return;
    root.dataset.productReady = 'true';

    const variants = parseVariants(root);
    const selects = [...root.querySelectorAll('[data-product-option]')];
    const variantInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const availability = root.querySelector('[data-product-availability]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const addText = root.querySelector('[data-add-to-cart-text]');
    const quantity = root.querySelector('[data-product-quantity]');
    const gallery = root.querySelector('[data-product-gallery]');

    const activateMedia = mediaId => {
      if (!mediaId || !gallery) return;
      gallery.querySelectorAll('[data-product-media]').forEach(item => {
        if (String(item.dataset.mediaId) === String(mediaId)) item.dataset.active = 'true';
        else item.removeAttribute('data-active');
      });
      gallery.querySelectorAll('[data-product-thumbnail]').forEach(button => {
        if (String(button.dataset.mediaId) === String(mediaId)) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    };

    if (gallery) {
      gallery.classList.add('product-gallery--enhanced');
      gallery.addEventListener('click', event => {
        const thumbnail = event.target.closest('[data-product-thumbnail]');
        if (thumbnail) activateMedia(thumbnail.dataset.mediaId);
      });
    }

    const choices = () => selects.map(select => select.value);
    const findVariant = () => variants.find(variant => variant.options.every((value, index) => value === choices()[index]));

    const updateOptionStates = () => {
      const selected = choices();
      selects.forEach((select, index) => {
        [...select.options].forEach(option => {
          const hasAvailablePath = variants.some(variant => variant.available && variant.options[index] === option.value && variant.options.slice(0, index).every((value, previousIndex) => value === selected[previousIndex]));
          option.disabled = !hasAvailablePath && option.value !== select.value;
        });
      });
    };

    const renderVariant = variant => {
      const available = Boolean(variant?.available);
      if (variantInput) variantInput.value = variant?.id || '';
      if (price) {
        const template = root.querySelector(`[data-variant-price="${variant?.id}"]`);
        if (template) price.innerHTML = template.innerHTML;
      }
      if (availability) availability.lastChild.textContent = ` ${variant ? (available ? root.dataset.inStockLabel : root.dataset.soldOutLabel) : root.dataset.unavailableLabel}`;
      if (addButton) addButton.disabled = !available;
      if (addText) addText.textContent = variant ? (available ? root.dataset.addLabel : root.dataset.soldOutLabel) : root.dataset.unavailableLabel;
      const mediaId = variant?.featured_media_id;
      activateMedia(mediaId);
      if (variant?.id && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };

    selects.forEach(select => select.addEventListener('change', () => {
      updateOptionStates();
      renderVariant(findVariant());
    }));
    root.querySelectorAll('[data-quantity-change]').forEach(button => button.addEventListener('click', () => {
      if (!quantity) return;
      const next = Math.max(Number(quantity.min) || 1, (Number(quantity.value) || 1) + Number(button.dataset.quantityChange));
      quantity.value = String(next);
    }));

    updateOptionStates();
    renderVariant(variants.find(variant => String(variant.id) === String(variantInput?.value)) || findVariant());
  }

  const initializeAll = scope => scope.querySelectorAll('[data-product-root]').forEach(initialize);
  document.addEventListener('DOMContentLoaded', () => initializeAll(document));
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
})();
